export enum ContentLanguage {
  ENGLISH = 'en',
  GERMAN = 'de',
  FRENCH = 'fr',
  SPANISH = 'es',
  ZULU = 'zu'
}
